import React from "react";
import "./styles.scss";

const BoxIntegrationSkeleton = () => (
    <div className="box-integration-skeleton">
        <div className="skeleton-header">
            <div className="skeleton skeleton-logo" />
            <div className="skeleton skeleton-badge" />
        </div>
        <div className="skeleton-content">
            <div className="skeleton skeleton-title" />
            <div className="skeleton skeleton-line short" />
            <div className="skeleton skeleton-line" />
            <div className="skeleton skeleton-products" />
        </div>
        <div className="skeleton skeleton-btn" />
    </div>
);

export default BoxIntegrationSkeleton;
